module.exports = __webpack_public_path__ + "img/header.642bfdda.png";